import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteMajorByIdOperation = async (
  majorId: number,
  setDeleteMajorId: (majorId: number | null) => any,
) => {
  try {
    setDeleteMajorId(majorId);
    // TODO api call

    const res = await appApi.deleteMajor(majorId);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setDeleteMajorId(null);
      return;
    }
    globalSettingsStores.fetchSetting();
    setDeleteMajorId(null);
  } catch (e) {
    console.error(
      `deleteMajorByIdOperation is failed with the majorId: ${majorId} and the error: ${e}`,
    );
    setDeleteMajorId(null);
  }
};
